// Textarea field - mode-aware (renders readonly in view modes)
import { useFormContext } from 'react-hook-form';
import { TextArea, FieldError, FieldWrapper, FieldDisplay } from '@startus/ui';
import { useFormMode } from '../../hooks/useFormMode';
import type { BaseFieldProps } from '../../types/fields';

// Helper to get nested error from formState.errors using dot notation path
function getNestedError(errors: Record<string, unknown>, path: string): string | undefined {
  const parts = path.split('.');
  let current: unknown = errors;
  for (const part of parts) {
    if (current === null || current === undefined) return undefined;
    current = (current as Record<string, unknown>)[part];
  }
  return (current as { message?: string })?.message;
}

export function TextAreaField({ name, label, placeholder, required, maxLength }: BaseFieldProps) {
  const { isReadOnly } = useFormMode();
  const {
    register,
    watch,
    formState: { errors },
  } = useFormContext();

  const value = watch(name);
  const error = getNestedError(errors, name);

  if (isReadOnly) {
    return <FieldDisplay label={label} value={value} required={required} />;
  }

  return (
    <FieldWrapper>
      {/*<Label required={required} fieldNumber={fieldNumber}>{label}</Label>*/}
      <TextArea
        {...register(name, { maxLength })}
        placeholder={placeholder}
        error={!!error}
        rows={4}
        maxLength={maxLength}
      />
      <FieldError message={error} />
    </FieldWrapper>
  );
}
